// 存放记录的数组
let jumpLogs = {};
// 添加一个标志来防止重复绑定scroll事件
let scrollListenerBound = false;

// 判断是否是input区域
function isInput(el) {
  const dataToggle = el.getAttribute("data-toggle");
  return dataToggle && dataToggle === "input"; // input区域
}
// 过滤按钮文字里的符号，只保留中英文、数字、空格
function cleanButtonName(text) {
  return text.replace(/[^a-zA-Z0-9\u4e00-\u9fa5\s]/g, "").trim();
}
// 处理 linkUrl，补全域名
function formatLinkUrl(rawLink) {
  if (!rawLink) return "";

  try {
    // new URL(url, base) 会自动解析相对路径
    const absoluteUrl = new URL(rawLink, window.location.href);
    return absoluteUrl.href;
  } catch (e) {
    console.warn("Invalid URL:", rawLink);
    return rawLink;
  }
}
// 记录按钮信息
function recordBehavior(el, behaviorType, extraData = {}) {
  let moduleName = "";
  let buttonName = "";
  let link = "";
  let clickActionResult = "";
  let ctaType = "";
  let ctaId = "";
  if (el) {
    moduleName = el.getAttribute("data-module") || "未知模块";
    const rawButtonName =
      el.innerText.trim() ||
      el.getAttribute("title") ||
      el.getAttribute("aria-label") ||
      el.getAttribute("placeholder") ||
      "未命名按钮";
    buttonName = cleanButtonName(rawButtonName); // 过滤掉符号
    const rawLink =
      el.getAttribute("href") || el.getAttribute("data-link") || "";
    link = formatLinkUrl(rawLink);
    clickActionResult = el.getAttribute("data-result");
    ctaType = el.getAttribute("data-ctaType") || "";
    ctaId = el.getAttribute("data-ctaId") || "";
  }
  const userBehaviorLog = sessionStorage.getItem("userBehaviorLog")
    ? JSON.parse(sessionStorage.getItem("userBehaviorLog"))
    : {};
  if (ctaType) {
    // 点击了cta按钮
    userBehaviorLog.isClickCta = true;
    sessionStorage.setItem("userBehaviorLog", JSON.stringify(userBehaviorLog));
  }
  jumpLogs = {
    browser: userBehaviorLog.browser,
    browserVersion: userBehaviorLog.browserVersion,
    device: userBehaviorLog.device,
    officialSystem: "vue",
    userAgent: userBehaviorLog.userAgent,
    requestUuid: userBehaviorLog.requestUuid,
    inquiryPackageId: userBehaviorLog.inquiryPackageId,
    dataTemplateId: userBehaviorLog.dataTemplateId,
    entityId: userBehaviorLog.entityId,
    sessionId: userBehaviorLog.sessionId,
    requester: userBehaviorLog.requester,
    pageUrl: window.location.href,
    pageName: document.title || "未知",
    websiteId: userBehaviorLog.websiteId,
    browserSize: userBehaviorLog.browserSize,
    behaviorTime: new Date().getTime(),
    moduleName: moduleName,
    clickedElementName: buttonName,
    clickActionResult: clickActionResult,
    linkUrl: link,
    linkText: buttonName,
    behaviorType: behaviorType,
    ctaText: buttonName,
    ctaType: ctaType,
    ctaId: ctaId,
    pageHeight: Number(document.documentElement.scrollHeight),
    pageWidth: Number(document.documentElement.scrollWidth),
    ...extraData,
  };
  if (behaviorType === "CLICK" || behaviorType === "HOVER") {
    if (moduleName && clickActionResult) {
      behaviorUpdate();
    }
  } else {
    behaviorUpdate();
  }
}
function behaviorUpdate() {
  // 判断是否 ims 打开的预览
  const urlParams = new URLSearchParams(window.location.search);
  if (urlParams.has("imsPreview")) {
    console.log("IMS 预览模式，埋点逻辑已禁用");
    return;
  }
  let devUrl = "https://dev-plat.cnabke.com";
  let testUrl = "https://test-plat.cnabke.com";
  let masterUrl = "https://plat.cnabke.com";
  let nowUrl = "";
  // let url = "/app-crm/data/user/gw/create";
  let url = "/app-ims/websiteUserPageBehavior/createSubUserBehavior";
  if (window.location.hostname.indexOf("dev-") !== -1) {
    nowUrl = devUrl + url;
  } else if (
    window.location.hostname.indexOf("test") !== -1 ||
    window.location.hostname.indexOf("localhost") !== -1 ||
    window.location.hostname.indexOf("127") !== -1
  ) {
    nowUrl = testUrl + url;
  } else {
    nowUrl = masterUrl + url;
  }
  const params = JSON.stringify(jumpLogs);
  return navigator.sendBeacon(nowUrl, params);
}
// 给所有带 data-module 的按钮绑定监听
// 绑定点击事件
function bindClickListeners() {
  const elements = document.querySelectorAll("[data-module]");
  elements.forEach((el) => {
    // 如果是输入框，不绑定 click 事件，避免重复上报
    if (
      el.tagName.toLowerCase() === "input" ||
      el.tagName.toLowerCase() === "textarea"
    ) {
      return;
    }
    el.addEventListener("click", function(event) {
      const rect = el.getBoundingClientRect();
      const extraData = {
        positionX: event.clientX,
        positionY: event.clientY,
        elementWidth: rect.width,
        elementHeight: rect.height,
        inputContent: "", // 点击行为没有输入内容
      };
      recordBehavior(el, "CLICK", extraData);
    });
  });
}
// 绑定输入事件
function bindInputListeners() {
  const inputs = document.querySelectorAll(
    "input[data-module], textarea[data-module]"
  );
  inputs.forEach((el) => {
    el.addEventListener("blur", function() {
      const rect = el.getBoundingClientRect();
      const extraData = {
        positionX: rect.x,
        positionY: rect.y,
        elementWidth: rect.width,
        elementHeight: rect.height,
        inputContent: el.value, // 输入的内容
      };
      recordBehavior(el, "INPUT", extraData);
    });
  });
}
// 绑定 Hover 事件（悬停 5 秒才触发）
function bindHoverListeners() {
  const hoverElements = document.querySelectorAll("[data-module]");
  hoverElements.forEach((el) => {
    let hoverTimer = null;

    el.addEventListener("mouseenter", function() {
      hoverTimer = setTimeout(() => {
        const rect = el.getBoundingClientRect();
        const extraData = {
          positionX: rect.x,
          positionY: rect.y,
          elementWidth: rect.width,
          elementHeight: rect.height,
        };

        recordBehavior(el, "HOVER", extraData);
      }, 5000); // 悬停 5 秒
    });

    el.addEventListener("mouseleave", function() {
      if (hoverTimer) {
        clearTimeout(hoverTimer);
        hoverTimer = null;
      }
    });
  });
}

// 绑定滚动事件
function bindScrollListeners() {
  // 如果已经绑定过scroll监听器，直接返回
  if (scrollListenerBound) {
    return;
  }

  let scrollTimer = null;
  let scrollStartTime = 0;
  let scrollStartX = 0;
  let scrollStartY = 0;
  let startModuleName = "";
  let lastKnownElement = null;

  // 用mousemove事件跟踪鼠标所在元素
  document.addEventListener("mousemove", function(e) {
    const target = e.target;
    let currentElement = target;
    while (currentElement && !currentElement.getAttribute("data-module")) {
      currentElement = currentElement.parentElement;
    }
    if (currentElement) {
      lastKnownElement = currentElement;
    }
  });

  window.addEventListener("scroll", function() {
    const now = Date.now();

    if (!scrollStartTime) {
      // 记录滚动起始点
      scrollStartTime = now;
      scrollStartX = window.scrollX;
      scrollStartY = window.scrollY;

      // 使用最后已知的元素
      startModuleName = lastKnownElement
        ? lastKnownElement.getAttribute("data-module")
        : "未知模块";
    }

    if (scrollTimer) clearTimeout(scrollTimer);

    // 停止 200ms 判定为滚动结束
    scrollTimer = setTimeout(() => {
      const slideEndX = window.scrollX;
      const slideEndY = window.scrollY;
      const duration = now - scrollStartTime;

      const deltaX = slideEndX - scrollStartX;
      const deltaY = slideEndY - scrollStartY;

      // ✅ 滑动阈值过滤（避免小抖动）
      if (Math.abs(deltaY) > 350 || Math.abs(deltaX) > 100) {
        const extraData = {
          slideStartX: scrollStartX,
          slideStartY: scrollStartY,
          slideEndX,
          slideEndY,
          duration,
          moduleName: startModuleName, // 添加开始滚动时所在的模块名称
        };

        recordBehavior(null, "SCROLL", extraData);
      }

      // 重置
      scrollStartTime = 0;
      scrollStartX = 0;
      scrollStartY = 0;
      startModuleName = "";
    }, 200);
  });
  // 标记为已绑定
  scrollListenerBound = true;
}

// 初始化
// document.addEventListener("DOMContentLoaded", () => {
//   bindClickListeners();
//   bindInputListeners();
//   bindHoverListeners();
//   bindScrollListeners();
// });
export default {
  init() {
    console.log("init buttonStorage");
    bindClickListeners();
    bindInputListeners();
    bindHoverListeners();
    bindScrollListeners();
  },
};
